import * as React from 'react'

export function TabbarSettingsLts(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M16 21c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m11.235-6.529l-2.439-.369a8.953 8.953 0 00-1.237-2.976l1.467-1.989a.767.767 0 000-1.082l-1.081-1.081a.763.763 0 00-1.081 0l-1.99 1.467a8.944 8.944 0 00-2.976-1.237l-.369-2.439A.764.764 0 0016.765 4h-1.53a.764.764 0 00-.764.765l-.369 2.439a8.944 8.944 0 00-2.976 1.237L9.137 6.974a.765.765 0 00-1.082 0L6.974 8.055a.767.767 0 000 1.082l1.467 1.989a8.953 8.953 0 00-1.237 2.976l-2.439.369a.764.764 0 00-.765.764v1.53c0 .422.342.764.765.764l2.439.369a8.944 8.944 0 001.237 2.976l-1.467 1.989a.767.767 0 000 1.082l1.081 1.081a.767.767 0 001.082 0l1.989-1.467a8.937 8.937 0 002.978 1.237l.367 2.439c0 .423.342.765.764.765h1.53a.764.764 0 00.764-.765l.369-2.439a8.944 8.944 0 002.976-1.237l1.99 1.467a.765.765 0 001.081 0l1.081-1.081a.767.767 0 000-1.082l-1.467-1.989a8.944 8.944 0 001.237-2.976l2.439-.369a.764.764 0 00.765-.764v-1.53a.764.764 0 00-.765-.764'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
